// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vy-z","smallCardRow":"wy-z","largeCardRow":"xy-z","productSearchRow":"yy-z","curatedRow":"zy-z"};